<template>
	<div class="tableBox">
		<div class="box"></div>
		<div class="title">
			<div :class="`inlin ${className}`">
				<i :class="`iconfont ${icon} tableIcon`"></i>
				<span class="fz14">{{title}}排名</span>
				<!--<div class="tableDifferential">
					<span>
						最高分：95分（王xx—北京影像中心）
					</span>
					<br/>
					<span>
						最低分：95分（王xx—北京影像中心）
					</span>
				</div> -->
			</div>
			<div class="rt">
				<slot></slot>
			</div>
		</div>
		<div v-if="dataList&&dataList.length>0" style="height: 0;">
			<div class="table">
				<el-table class="qcTable scrollbar" :data="dataList" :row-class-name="tableRowClassName">
					<el-table-column prop="TotalRank" v-if="!unqualiColumn" label="排名" :key="1"></el-table-column>
					<el-table-column prop="DoctorName" label="姓名" :key="2"></el-table-column>
					<el-table-column v-if="!unqualiHeader" prop="HospitalName" show-overflow-tooltip label="影像中心" :key="3">
						<template slot-scope="scope">
							{{scope.row.HospitalName }}
						</template>
					</el-table-column>
					<el-table-column prop="AvgScore" v-if="!unqualiColumn" label="平均分" :key="4"></el-table-column>
					<el-table-column prop="ReportCount" v-if="unqualiColumn" label="份数" :key="6"></el-table-column>
					<el-table-column prop="" label="操作" :key="5">
						<template slot-scope="scope">
							<span class="tableOpe grlybtn" v-if="!unqualiColumn&&scope.row.DoctorName.indexOf('未知') != -1">暂无评估</span>
							<span class="tableOpe" v-else-if="!unqualiColumn" @click="pAssessment(scope.row)">个人评估</span>
							<span class="tableOpe" v-else @click="qualifiedClick(scope.row,'qualified')">报告列表</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pages" v-if="pageCount&&total&&pageIndex">
				<el-pagination class="pageAll" align="center" layout="prev, pager, next" :total="total" :page-size='pageCount'
				 :current-page='pageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
		<div v-else class="echartsNull">
			<div>
				<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
			</div>
			<div class="text">暂无数据</div>
		</div>
		
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		props:['dataList','className','icon','title','unqualiHeader','unqualiColumn','total','pageCount','pageIndex','name','type','unqualifiedStatus'],
		data() {
			return {
				// currentRow: null
			};
		},
		computed: {
			...Vuex.mapState('supervisor', ['QualifiedPart','GetReportListArr', 'breadcrumbList']),
			...Vuex.mapState('visualization', ['setDateArr','visbreadcrumbList']),
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType','clearRow']),
			...Vuex.mapMutations('supervisor',['currentChangesSecond','setLoading','settableLoading','setBreadcrumbList']),
			...Vuex.mapMutations('visualization',['setvisBreadcrumbList']),
			// ...Vuex.mapActions('doctor', ['GetReporterReportList']),
			//隔行换色
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 != 0) {
					return 'warning-row';
				}
				return '';
			},
			pAssessment(row){
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.setvisBreadcrumbList();
				this.visbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
				this.GetReportListArr.type = row.DoctorName;
				this.visbreadcrumbList.push(row.DoctorName);
				this.GetReportListArr.name = row.DoctorName;
				this.GetReportListArr.hospitalGuid = row.HospitalGuid;
				this.GetReportListArr.DoctorGuid = row.DoctorGuid;
				this.GetReportListArr.status = "personal";
				// this.GetReportListArr.unqualified = this.unqualifiedStatus;
				// if (this.tabType == this.tableType) {
				// 	this.GetReportListArr.tabType = this.tabType;
				// }else{
				// 	this.GetReportListArr.tabType = this.tableType;
				// }
				// if (this.GetReportListArr.tabType == undefined) {
				// 	this.GetReportListArr.tabType = 2;
				// }
				this.GetReportListArr.tabType = this.type;
				this.visbreadcrumbList.push(this.type);
				this.$router.push("/home/visualization/visPersonalAssessment");
			},
			//合格医生点击
			qualifiedClick(row, type) {
				if (this.visbreadcrumbList.length == 0) {
					this.visbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
				}
				// this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.QualifiedPart.hospitalGuid = row.HospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.visbreadcrumbList[0],row.DoctorName,"line");
				// this.breadcrumbList.push(row.DoctorName);
				// this.breadcrumbList.push("line");
				this.GetReportListArr.status = "personal";
				this.GetReportListArr.DoctorName  = row.DoctorName;
				this.GetReportListArr.unqualified = this.unqualifiedStatus;
				this.GetReportListArr.tabType = this.type;
				this.$router.push("/home/supervisor/qualifiedTable");
			},
			currentChange(val){
				this.$emit(this.name, val)
			}
		}
	
	}
</script>

<style>
</style>
